module.exports = __webpack_public_path__ + "media/images/cleaning/meriem@3x-41082c43b982cb68387d9936547ab399.jpg";